export default "__VITE_ASSET__BkoqLZ4o__"